module.exports = __webpack_public_path__ + "static/media/thumbnail_endosee-for-use.3bf50606.jpg";